import React from 'react';

const useCountDown = () => {
  const [endTime, setCountDownEndTime] = React.useState(0);
  const [isStart, setIsState] = React.useState(false);
  const [countDown, setCountDown] = React.useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  React.useEffect(() => {
    if (!endTime) return () => {};

    const tick = () => {
      const currentTime = new Date().getTime();
      const distanceToDate = endTime - currentTime;
      const days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distanceToDate % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      setCountDown({
        days: `${Math.max(days, 0)}`.padStart(2, '0'),
        hours: `${Math.max(hours, 0)}`.padStart(2, '0'),
        minutes: `${Math.max(minutes, 0)}`.padStart(2, '0'),
        seconds: `${Math.max(seconds, 0)}`.padStart(2, '0'),
      });

      if (!isStart) {
        setIsState(true);
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [endTime]);

  return [countDown, isStart, setCountDownEndTime];
};

export default useCountDown;
